module.exports = __webpack_public_path__ + "img/dropdown-v_black.945d2649.svg";